import React, {Fragment, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {ConfirmCancel} from "./ConfirmModal";
import {Control} from "react-hook-form/dist/types";
import {useFormState} from "react-hook-form";
import {FieldValues} from "react-hook-form/dist/types/fields";
import classNames from "classnames";

interface ModalPanelProps {
    header?: React.ReactNode,
    footer?: React.ReactNode,
    children: React.ReactNode,
    isOpen: boolean,
    handleDismiss: () => void,
    bgColor?: string,
    margin?: string,
}

export const ModalPanel: React.FC<ModalPanelProps> = ({
                                                          header, footer, children, isOpen, handleDismiss,
                                                          bgColor = 'bg-white',
                                                          margin = '',
                                                      }) => {
    return (
        <>
            <Transition.Root show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={() => handleDismiss()}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"/>
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex sm:p-0 justify-center my-9">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >

                                <Dialog.Panel
                                    className={classNames('relative transform overflow-hidden rounded-lg shadow-xl transition-all', bgColor, margin)}>
                                    {header}
                                    {/*<div className="mx-2 mb-2 sm:mx-4 sm:mb-4 sm:w-full 2xl:max-w-fit">*/}
                                    <div className="mx-2 mb-2 sm:mx-4 sm:mb-4">
                                        {children}
                                    </div>
                                    {footer}
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    )
}

interface ModalPanelFormProps<T extends FieldValues> extends ModalPanelProps {

    formControl: Control<T>,
    isChanged?: () => boolean
}

export function ModalPanelForm<T extends FieldValues>(props: ModalPanelFormProps<T>) {
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);
    const {isDirty: isDirtyForm} = useFormState<T>({control: props.formControl});
    const isDirty = (props.isChanged && props.isChanged()) || isDirtyForm;
    const closeHandle = () => {
        if (isDirty)
            setIsOpenConfirm(true);
        else
            props.handleDismiss();
        /*
        if (isOpenConfirm) {
            setIsOpenConfirm(false);
        } else {
            if (isDirty)
                setIsOpenConfirm(true);
            else
                props.handleDismiss();
        }
        */
    }
    return (
        <>
            <ModalPanel isOpen={props.isOpen} header={props.header} handleDismiss={closeHandle}>{props.children}</ModalPanel>
            {
                isOpenConfirm && (
                    <ConfirmCancel
                        onCancel={() => {
                            setIsOpenConfirm(false);
                        }}
                        onConfirm={() => {
                            setIsOpenConfirm(false);
                            props.handleDismiss();
                        }}
                    />
                )
            }
        </>
    )
}